import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './i18n';
import './index.css';

/* Layout principal */
import MainLayout from './components/layout/MainLayout';

/* Chargement différé des pages (code splitting) */
const Home = lazy(() => import('./pages/Home'));
const Ecosystem = lazy(() => import('./pages/Ecosystem'));
const Services = lazy(() => import('./pages/Services'));
const BrandPage = lazy(() => import('./pages/BrandPage'));
const KolaboEdu = lazy(() => import('./pages/KolaboEdu'));
const KolaboHub = lazy(() => import('./pages/KolaboHub'));
const KolaboLab = lazy(() => import('./pages/KolaboLab'));
// const Team = lazy(() => import('./pages/Team'));
const Blog = lazy(() => import('./pages/Blog'));
const BlogPost = lazy(() => import('./pages/BlogPost'));
const Contact = lazy(() => import('./pages/Contact'));
const Privacy = lazy(() => import('./pages/Privacy'));
const Terms = lazy(() => import('./pages/Terms'));
const NotFound = lazy(() => import('./pages/NotFound'));

/**
 * Écran de chargement pendant le lazy loading
 */
function LoadingFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center">
        <div className="w-12 h-12 rounded-xl bg-accent-gradient flex items-center justify-center mx-auto mb-4 animate-pulse shadow-glow">
          <span className="text-white font-display font-bold text-xl"><img src="/zig.jpeg" alt="Zig Investment" className='w-12 h-12 rounded-xl' /></span>
        </div>
        <p className="text-navy-400 text-sm font-body">Chargement...</p>
      </div>
    </div>
  );
}

/**
 * Application principale
 * Routes localisées : /:locale/*
 * Locales supportées : fr, en, ht
 */
function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            {/* Redirection racine vers /fr */}
            <Route path="/" element={<Navigate to="/fr" replace />} />

            {/* Routes localisées */}
            <Route path="/:locale" element={<MainLayout />}>
              <Route index element={<Home />} />
              <Route path="ecosysteme" element={<Ecosystem />} />
              <Route path="services" element={<Services />} />
              <Route path="marques/:slug" element={<BrandPage />} />
              <Route path="kolabo-edu" element={<KolaboEdu />} />
              <Route path="kolabo-hub" element={<KolaboHub />} />
              <Route path="kolabo-lab" element={<KolaboLab />} />
              {/* <Route path="equipe" element={<Team />} /> */}
              <Route path="blog" element={<Blog />} />
              <Route path="blog/:slug" element={<BlogPost />} />
              <Route path="contact" element={<Contact />} />
              <Route path="privacy" element={<Privacy />} />
              <Route path="terms" element={<Terms />} />
              <Route path="*" element={<NotFound />} />
            </Route>

            {/* Catch-all → /fr */}
            <Route path="*" element={<Navigate to="/fr" replace />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
